import find from 'lodash/find';
import get from 'lodash/get';
import produce from 'immer';
import set from 'lodash/set';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import analytics from '@ad-scripts/lib/analytics';
import ivrsResource from 'src/actions/ivrs/ivrsResource';
import { toastError } from 'src/actions/toast';

export default function useSaveIvrName(ivrsIdNameMap, setIvrsIdNameMap) {
  const dispatch = useDispatch();

  return useCallback(
    (item, newName = '') => {
      const id = item.id;
      const trimmedNewName = newName.trim();
      const lowerCasedName = trimmedNewName.toLowerCase();

      if (!trimmedNewName) {
        dispatch(toastError('Name is required'));
        return;
      }

      const hasItemWithTheSameName = find(
        ivrsIdNameMap,
        (ivr, ivrId) => ivrId !== id && get(ivr, 'name', '').toLowerCase() === lowerCasedName
      );

      if (hasItemWithTheSameName) {
        dispatch(toastError('Name already exists'));
        return;
      }

      dispatch(ivrsResource.effects.renameIvr({ id }, { name: trimmedNewName }));
      const newConfig = produce(ivrsIdNameMap, draft => set(draft, `[${id}].name`, trimmedNewName));
      setIvrsIdNameMap(newConfig);
      analytics.track('Admin - IVR Rename', { ivrId: id, version: item.version });
    },
    [dispatch, ivrsIdNameMap, setIvrsIdNameMap]
  );
}
